import { render } from "./BaseList.vue?vue&type=template&id=b2129ee0&scoped=true"
import script from "./BaseList.vue?vue&type=script&lang=js"
export * from "./BaseList.vue?vue&type=script&lang=js"

import "./BaseList.vue?vue&type=style&index=0&id=b2129ee0&lang=scss&scoped=true"
import "./BaseList.vue?vue&type=style&index=1&id=b2129ee0&lang=scss"
script.render = render
script.__scopeId = "data-v-b2129ee0"

export default script